import api from "./api"; // Centralized authenticated Axios instance

export async function getCommissionTiers() {
  try {
    const res = await api.get("/store/commission-tiers");
    return res.data.data || res.data;
  } catch (error) {
    const errorText = error.response?.data?.message || error.message;
    throw new Error(`Failed to fetch tiers: ${errorText}`);
  }
}

export async function createCommissionTier(data) {
  try {
    const res = await api.post("/store/commission-tiers", data);
    return res.data.data || res.data;
  } catch (error) {
    const errorText = error.response?.data?.message || error.message;
    throw new Error(`Failed to create tier: ${errorText}`);
  }
}

export async function updateCommissionTier(name, data) {
  try {
    const res = await api.put(
      `/store/commission-tiers/${encodeURIComponent(name)}`,
      data,
    );
    return res.data.data || res.data;
  } catch (error) {
    const errorText = error.response?.data?.message || error.message;
    throw new Error(`Failed to update tier: ${errorText}`);
  }
}

export async function deleteCommissionTier(name) {
  try {
    const res = await api.delete(
      `/store/commission-tiers/${encodeURIComponent(name)}`,
    );
    return res.data;
  } catch (error) {
    const errorText = error.response?.data?.message || error.message;
    throw new Error(`Failed to delete tier: ${errorText}`);
  }
}

// const API_BASE = "http://10.5.21.42:5000/api/store/commission-tiers";

// // No normalization or conversion of numbers, just send/receive as-is

// async function handleResponse(res, errorMsg) {
//   if (!res.ok) {
//     const errorText = await res.text();
//     throw new Error(`${errorMsg}: ${res.status} ${errorText}`);
//   }
//   return res.json();
// }

// export async function getCommissionTiers() {
//   const res = await fetch(API_BASE);
//   return handleResponse(res, "Failed to fetch tiers");
// }

// export async function createCommissionTier(data) {
//   const res = await fetch(API_BASE, {
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify(data), // send as-is
//   });
//   return handleResponse(res, "Failed to create tier");
// }

// export async function updateCommissionTier(name, data) {
//   const res = await fetch(`${API_BASE}/${encodeURIComponent(name)}`, {
//     method: "PUT", // or PATCH if your backend supports partial updates
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify(data), // send as-is
//   });
//   return handleResponse(res, "Failed to update tier");
// }

// export async function deleteCommissionTier(name) {
//   const res = await fetch(`${API_BASE}/${encodeURIComponent(name)}`, {
//     method: "DELETE",
//   });
//   if (!res.ok) {
//     const errorText = await res.text();
//     throw new Error(`Failed to delete tier: ${res.status} ${errorText}`);
//   }
// }
